import React from 'react';
import { array, string, func, bool } from 'prop-types';
import Branch from './Branch';
import RadioButtonGroup from '../RadioButtonGroup/RadioButtonGroup';
import RadioButton from '../RadioButton/RadioButton';
import styles from './BranchList.scss';
import classNames from 'classnames';

export default function BranchList({ branches, value, onChange, isLoading }) {
  return (
    <RadioButtonGroup
      value={value}
      onChange={onChange}
      className={classNames([styles.group, isLoading && styles.loading])}
      itemClassName={styles.item}
    >
      {branches.map((branch, index) => (
        <RadioButton name="branch" value={branch.id} key={branch.id || index} disabled={isLoading}>
          <Branch {...branch} isLoading={isLoading} />
        </RadioButton>
      ))}
    </RadioButtonGroup>
  );
}

BranchList.displayName = 'BranchList';

BranchList.propTypes = {
  branches: array,
  value: string,
  onChange: func,
  isLoading: bool,
};

BranchList.defaultProps = {
  branches: [],
};
